<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3" ref="searchDiv">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 订單编碼 |快递單號" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >總充值：{{total_list.total}}</el-tag> -->
					<!-- <el-button class="mr-2"  @click="openModel(false,1)" type="primary" size="mini" 
					v-auth="'add'+auth_val">入库</el-button> -->
					<!-- <el-button type="primary" v-auth="'add'+auth_val" @click="openModel(2)" size="mini">手动开單</el-button> -->

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="商品名稱|SKU" class="mb-0">
							<el-input size="small" v-model="from.sku" placeholder="搜索商品名稱|SKU"></el-input>
						</el-form-item>
						<el-form-item label="快递單號" class="mb-0">
							<el-input size="small" v-model="from.number" placeholder="搜索快递單號"></el-input>
						</el-form-item>
						<el-form-item label="订單编號" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索订單编號"></el-input>
						</el-form-item>
						
						<el-form-item label="商戶">
							<el-select v-model="from.shop_id" multiple  clearable size="small" filterable placeholder="請選擇" style="width: 85%;">
								<!-- <el-option  label="全部" :value="-1"> -->
								<!-- </el-option> -->
								<el-option v-for="item in shop_list" :key="item.id" :label="item.name+'（'+item.username+')'" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item label="订單類型" class="mb-0">
							<el-select v-model="from.type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="发货單" :value="1"></el-option>
								<el-option label="退货單" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						
						
						
						<el-form-item label="来源" class="mb-0">
							<el-select v-model="from.from_type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="电商平台自动下單" :value="1"></el-option>
								<el-option label="手动創建" :value="2"></el-option>
							</el-select>
						</el-form-item>
					
						
						<el-form-item label="电商平台" class="mb-0">
							<el-select v-model="from.s_type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="TikTok" :value="1"></el-option>
								<el-option label="Shopee" :value="2"></el-option>
								<el-option label="Lazada" :value="3"></el-option>
							</el-select>
						</el-form-item>
						
						<!-- <el-form-item label="狀態" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="待分配" :value="0"></el-option>
								<el-option label="已发货" :value="1"></el-option>
								<el-option label="待发货" :value="2"></el-option>
								<el-option label="未找到对应商品" :value="3"></el-option>
								<el-option label="未找到可发货仓库" :value="4"></el-option>
								<el-option label="已取消" :value="99"></el-option>
								<el-option label="商戶取消订單" :value="8"></el-option>
								<el-option label="已签收" :value="9"></el-option>
								<el-option label="待確認" :value="10"></el-option>

							</el-select>
						</el-form-item> -->
						
					


						<el-form-item label="下單時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
			
			<div class="order_tabs">
				<el-tabs type="border-card" v-model="type" @tab-click="selOrderStatus">
				  <el-tab-pane name="10" :label="'待確定 '+total_list.total_10"></el-tab-pane>
				  <el-tab-pane name="100" :label="'待處理 '+total_list.total_100"></el-tab-pane>
				  <el-tab-pane name="2" :label="'待打單 '+total_list.total_2"></el-tab-pane>
				  <el-tab-pane name="11" :label="'待揽收 '+total_list.total_11"></el-tab-pane>
				  <el-tab-pane name="1" :label="'已交运 '+total_list.total_1"></el-tab-pane>
				  <el-tab-pane name="9" :label="'已签收 '+total_list.total_9"></el-tab-pane>
				  <el-tab-pane name="12" :label="'已完成 '+total_list.total_12"></el-tab-pane>
				  <el-tab-pane name="101" :label="'已取消 '+total_list.total_101"></el-tab-pane>
				</el-tabs>
			</div>
			
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange" :max-height="tableHeight"  :row-class-name="tableRowClassName"    default-expand-all>
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				
				
				<el-table-column type="expand" label="商品" width="80">
				  <template slot-scope="v">
					  <el-table
						:data="v.row.log"
						border
						 max-height	="450"
						style="width: auto;">
						
						<el-table-column width="280" align="center" prop="pro_name"  label="商品信息">
							<template slot-scope="v">
								<div style="display: flex;justify-content: space-between;align-items: center;">
									<div>
										<el-image v-if="v.row.head" style="width: 60px; height: 60px" :src="v.row.head" :preview-src-list="[v.row.head]"></el-image>
									</div>
									<div style="text-align: left;" v-if="v.row.pid!=0">
										<div>{{v.row.pro_name}}</div>
										<div style="font-size: 13px;color: #999;">SKU：{{v.row.sku}}</div>
									</div>
									
								</div>
								
								
							</template>
						</el-table-column>
						
						
						<el-table-column width="120" align="center" prop="num"  label="下單數量"></el-table-column>
						<el-table-column width="100" align="center" prop="pro_id"  label="狀態">
							<template slot-scope="k">
								<span class="text-success" v-if="k.row.status==1">已匹配商品</span>
								<span class="text-danger" v-if="k.row.status==0">无匹配商品</span>
								<span v-if="k.row.status==2">-</span>
							</template>
						</el-table-column>
						
						<el-table-column width="220" align="center" prop="pro_id"  label="电商平台SKU"></el-table-column>
						
						<el-table-column width="620" align="center" prop="name"  label="电商平台商品名稱"></el-table-column>
						
						
						
						
						
						
					
						
					
					  </el-table>
												  
					  </el-tab-pane>
						
					</template>
				</el-table-column>
							
							
				
				
				<!-- <el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column> -->
			
				
			
		
				
				
				<el-table-column align="center" width="220" prop="order_no" label="订單编號">
				</el-table-column>
				
				
				<el-table-column align="center" prop="sp_name" width="150" label="对应商戶">
					<template slot-scope="v">
						<span>{{v.row.shop_name}}(<span class="text-danger">{{v.row.username}}</span>)</span>
						
					</template>
				</el-table-column>
				
				
				
				<el-table-column width="180" align="center" prop="rts_sla_time" sortable label="最遲发货時間">
				  <template slot-scope="v">
					  <span v-if="v.row.countdown>0">{{ formatTime(v.row.countdown) }}</span>
					  <span v-else>{{v.row.rts_sla_time}}</span>
				  </template>
				</el-table-column>
				
				<el-table-column align="center" width="100"  prop="s_type"  label="订單類型">
					<template slot-scope="v">
						<span v-if="v.row.type==1" >发货單</span>
						<span v-if="v.row.type==2" >退货單</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="140"  prop="from_type"  label="来源">
					<template slot-scope="v">
						<span v-if="v.row.from_type==1" >电商平台自动下單</span>
						<span v-if="v.row.from_type==2" >手动創建</span>
						<span v-if="v.row.from_type==3" >手动导入</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="100"  prop="s_type"  label="电商平台">
					<template slot-scope="v">
						<span v-if="v.row.s_type==1" >TikTok</span>
						<span v-if="v.row.s_type==2" >Shoopee</span>
						<span v-if="v.row.s_type==3" >Lazada</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="120" sortable prop="total_amount" label="订單總金額">
					<template slot-scope="v">
						<span >HK$ {{v.row.total_amount}}</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="120" prop="stk_name" label="店铺">
				</el-table-column>
				
				
				<el-table-column align="center" width="180"  prop="num"  label="狀態">
					<template slot-scope="v">
						
						
						
						<span style="color: #888;" v-if="v.row.status==0">待分配</span>
						<span class="text-success" v-if="v.row.status==1">已交运</span>
						<span class="text-warning" v-if="v.row.status==2">待发货</span>
						<span class="text-danger" v-if="v.row.status==3">
							未找到对应商品
							<!-- <el-popover
							    placement="top-start"
							    title="提示"
							    width="250"
							    trigger="hover"
							    >
							    <div class="text-center">
									<div class="mb-2">平台商品SKU未在您拥有商品中找到对应SKU商品。正確设置完後等待系统检测即可自动发货！</div>
									<el-button @click="toOtherEdit(1)" size="mini" type="primary" plain>马上前往商品设置</el-button>
								</div>
								<el-button slot="reference" class="tis_btn"  circle>
									<span >?</span>
								</el-button>
							  </el-popover> -->
						</span>
						<span class="text-danger" v-if="v.row.status==4">
							未找到可发货仓库
							<!-- <el-popover
							    placement="top-start"
							    title="提示"
							    width="250"
							    trigger="hover"
							    >
							    <div class="text-center">
									<div class="mb-2">订單需要商品未发货海外仓货或无库存。請发货相应商品至海外仓。库存满足订單需求後系统将自动检测发货！</div>
									<el-button @click="toOtherEdit(2)" size="mini" type="primary" plain>马上去入库</el-button>
								</div>
								<el-button slot="reference" class="tis_btn"  circle>
									<span >?</span>
								</el-button>
							  </el-popover> -->
						</span>
						<span class="text-danger" v-if="v.row.status==5">已取消</span>
						<span class="text-danger" v-if="v.row.status==6">已取消</span>
						<span class="text-danger" v-if="v.row.status==7">已取消</span>
						<span class="text-danger" v-if="v.row.status==8">商戶取消订單</span>
						<span class="text-success" v-if="v.row.status==9">已签收</span>
						<span class="text-warning" v-if="v.row.status==10">待確認</span>
						<span class="text-warning" v-if="v.row.status==11">待揽件</span>
						<span class="text-success" v-if="v.row.status==12">已完成</span>
						
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="200" prop="e_number" label="快递單號">
					
					<template slot-scope="v">
						<span @click="showExpress(v.row.e_number)" class="text-blue text-a">{{v.row.e_number}}</span>
						
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="220" prop="order_id" label="平台订單ID">
				</el-table-column>
				
				<el-table-column align="center" width="160" prop="go_name"  label="发货仓库"></el-table-column>
				<el-table-column align="center" width="120" prop="client_name"  label="收件人"></el-table-column>
				<el-table-column align="center" width="160" prop="phone"  label="聯絡電話"></el-table-column>
				
			<el-table-column align="center" width="100" prop="local"  label="收货地址">
				<template slot-scope="v">
					<el-popover trigger="click" style="cursor: pointer;" placement="top">
					  <p style="width: 300px;">{{ v.row.local }}</p>
					  <div slot="reference" class="name-wrapper">
						<el-tag size="medium">查看</el-tag>
					  </div>
					</el-popover>
					
				</template>
			</el-table-column>
			
			
			<el-table-column align="center" prop="ok_img"  label="发货拍照">
				<template slot-scope="v">
					<el-image v-if="v.row.ok_img" style="width: 40px; height: 40px" :src="v.row.ok_img" :preview-src-list="[v.row.ok_img]"></el-image>
					<span v-else>-</span>
				</template>
			</el-table-column>
				
				
				
				
			
				<el-table-column align="center" width="160" prop="remark"  label="买家留言"></el-table-column>
			
				
	
			
		
				<!-- 
				<el-table-column align="center" sortable="custom" prop="status"  label="狀態">
					<template slot-scope="scope">
						<el-button :type="scope.row.status ? 'success' : 'danger'" size="mini" @click="changeStatus(scope.row)" plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
			 -->
		
			
				
					
			
				
			<el-table-column align="center" prop="ok_time" width="200" label="发货時間">
				
			</el-table-column>
	
				
		
				
				
				
				
				<el-table-column align="center" prop="open_time" width="200" label="下單時間">
					
				</el-table-column>
				
			
				
				

<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="80" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							
							
							
							<!-- <el-button v-if="(scope.row.status==3 && layout.user.ins_type==2) || ((scope.row.status==3 || scope.row.status==4) && layout.user.ins_type==1)" v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,1)">入库</el-button>
							
							<el-button v-if="scope.row.status==2 && layout.user.ins_type==2" v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,2)">出库</el-button>
							
							 -->
							 
							<el-button v-if="scope.row.status==1 || scope.row.status==2  || scope.row.status==9 && scope.row.type==1"   size="mini" plain type="info" @click="openPrintModel(scope.row)">面單</el-button>
							
							
							
						<!-- <el-button v-if="scope.row.status==2" @click="openModel(scope.row,2)"   size="mini" plain type="primary">发货</el-button> -->

						</el-button-group>
					</template>
				</el-table-column>


				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog :close-on-click-modal="false"  title="手动开單" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				<el-form-item label="电商平台"   prop="parent_type">
					<el-radio-group @change="changeStype" :disabled="editIndex>0?true:false" v-model="form.s_type">
					    <el-radio size="small" border :label="1">TikTok</el-radio>
					    <el-radio size="small" border :label="2">Shopee</el-radio>
					    <el-radio size="small" border :label="3">Lazada</el-radio>
					  </el-radio-group>
				</el-form-item>
				
				
				
				<el-form-item label="快递單號" prop="e_number">
					<el-input type="text" v-model="form.e_number" 
					placeholder="快递單號" 
					clearable size="small" style="width: 94%;">
					
					</el-input>
				</el-form-item>
				
				<el-row>
					<el-col :span="12">
						<el-form-item label="收件人" prop="client_name">
							<el-input type="text" v-model="form.client_name" 
							placeholder="收件人" 
							clearable size="small" style="width: 85%;">
							
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="聯絡電話" prop="client_name">
							<el-input type="text" v-model="form.phone" 
							placeholder="聯絡電話" 
							clearable size="small" style="width: 85%;">
							
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				
				<el-form-item label="收货地址" prop="local">
					<el-input type="text" v-model="form.local" 
					placeholder="收货地址" 
					clearable size="small" style="width: 94%;">
					
					</el-input>
				</el-form-item>
				
				
				<el-form-item label="买家留言" prop="remark">
					<el-input type="text" v-model="form.remark" 
					placeholder="买家留言" 
					clearable size="small" style="width: 94%;">
					
					</el-input>
				</el-form-item>
				
				
				
				<el-tag type="success" class="mb-2">订單商品：</el-tag>
				
				<table class="w-100">
					<tr v-for="(v,ii) in form.log" :key="ii">
						<td>
							<el-form-item  label-width="0px" prop="product">
								<el-select v-model="v.pid"  size="small" filterable placeholder="請選擇商品" style="width: 94%;">
									<el-option v-for="item in product" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</td>
						<td>
							<el-form-item  label-width="0px"  prop="num">
								<el-input type="number" v-model="v.num" 
								placeholder="发货數量" 
								clearable size="small" style="width: 94%;">
								
								</el-input>
							</el-form-item>
						</td>
						
						<td style="width: 80px;">
							
							<el-form-item label-width="0px"  >
	
								<el-button v-if="ii == (form.log.length - 1)" @click="addLog" size="small" type="success" icon="el-icon-plus" circle></el-button>
								<el-button @click="delLog(ii)" v-if="ii!=0" size="small" type="danger" icon="el-icon-delete" circle></el-button>
							</el-form-item>
							
						</td>
					</tr>
				</table>
			
				
				
				
			
				
				
				
				
				
				
				
				
				
				
				
				
				
				
			
				
			
			
				
				
				
	
				

				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button :loading="layout.loading" type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		
		
		
		<el-dialog :close-on-click-modal="false"  title="面單" :visible.sync="printModel" 
		top="5vh" :width="layout.is_phone?'100%':'500px'">
			<!-- 表單内容 -->
			<el-form :rules="rulesprint" ref="formEdit2" :model="printData" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				<div v-if="printData.print_img">
					<img style="width: 100%;height: auto;" :src="printData.print_img" alt="">
				</div>
				<div v-else class="text-center">
					暂无面單數据 ~
				</div>
				<!-- <div class="ex_model">
					<div class="p-2 ex_con">
						<div class="ex_head">
							<div >
								<div class="ex_head_com">
									<img class="ex_head_logo" src="https://api.fswss.com/static/fslogo2.png" alt="" >
									<div class="ml-2" >
										<div>Let\'s GO</div>
										<div>fswss.com</div>
									</div>
								</div>
								<div class="ex_head_time">
									{{currentTime}}
								</div>
								
							</div>

							<div class="ex_head_right" >
								<div>快 递</br>包 裹</div>
							</div>
							
							
							
						</div>
						<div class="ex_num" >
							{{printData.e_number}}
						</div>
						<div class="ex_num_img">
							<img  :src="printData.no_img" alt="">
						</div>
						<div class="ex_go">
							<div class="ex_go_icon">仓</div>
							<div>{{printData.go_name}}</div>
						</div>
						<div class="ex_data" >
							<div class="ex_data_left">
								<div class="ex_data_left_icon">收</div>
							</div>
							<div class="ex_data_right" >
								
								<div class="ex_data_right_name" >
									{{printData.client_name}}
									
									<span  class="ex_data_right_phone" >{{printData.phone}}</span>
								</div>
								
								<div>{{printData.local}}</div>
							</div>
						</div>
						
						<div class="ex_data ex_line">
							<div class="ex_data_left">
								<div class="ex_data_left_icon2">寄</div>
							</div>
							<div class="ex_data_right">
								<div class="ex_data_right_name">
									{{printData.addres}}
									
									<span class="ex_data_right_phone">{{printData.go_phone}}</span>
								</div>
								<div>{{printData.go_local}}</div>
							</div>
						</div>
						
						<div class="ex_pro" >
							<div v-for="v in printData.log" :key="v.id">
								{{v.pro_name}} *{{v.num}}
							</div>
							
						</div>
						
					
						
						
						
						
					</div>
				</div> -->
				
	
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="printModel = false">关 闭</el-button>
				<!-- <el-button type="primary" :loading="printload" @click="submitPrint">打 印</el-button> -->
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {

					e_number: [{
							required: true,
							message: "請輸入快递單號",
							trigger: 'blur',
						},
					],
					client_name: [{
							required: true,
							message: "請輸入收件人",
							trigger: 'blur',
						},
					],
					phone: [{
							required: true,
							message: "請輸入聯絡電話",
							trigger: 'blur',
						},
					],
					local: [{
							required: true,
							message: "請輸入收货地址",
							trigger: 'blur',
						},
					],
					
					
					
				},
				rulesprint:{
					
				},
				printModel: false,
				printload:false,
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					shop_id:'',
					username:'',
					sku:'',
					number:'',
					status:1,
					type:-1,
					from_type:-1,
					s_type:-1,
					time: [],
				},
				model_title: 'Order',
				auth_val: 'Order',
				preUrl: "data/orderList", //列表地址
				addUrl: "data/addOrder", //添加/修改地址
				editStatusUrl: "data/editStatusFirst", //修改狀態地址
				tableData: [],
				form: {
					id: 0,
					s_type:1,
					e_number:'',
					client_name:'',
					phone:'',
					local:'',
					remark:'',
					log:[],
				},
				copyData:{
					pid:'',
					num:''
				},
				printData:{
					id:0,
					log:[],
					no_img:'',
					client_name:'',
					phone:'',
					local:'',
					print_img:''

				},
				logItem:{
					pid:'',
					box:1,
					num:'',
				},
				prop: 'create_time',
				sort: 'descending',
				slist: [],
				plist: [],
				total_list: {
					total_1:0,
					total_2:0,
					total_9:0,
					total_10:0,
					total_11:0,
					total_12:0,
					total_100:0,
					total_101:0,
				},
				check_img_list: [],
				fileList: [],
				now_num:0,
				type:'10',
				godown_1:[],
				godown_2:[],
				product:[],
				product_1:[],
				product_2:[],
				product_3:[],
				currentTime:'',
				shop_list:[],
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			this.commonList('shopList');
			this.updateTime();
		},
		methods: {
			selOrderStatus(){
				this.getList()
				//this.selOrderStatus()
			},
			startCountdown(item) {
			    const interval = setInterval(() => {
			      if (item.countdown > 0) {
			        item.countdown--;
			      } else {
			        clearInterval(interval);
			      }
			    }, 1000);
			  },
			   formatTime(seconds) {
			      const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
			      const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
			      const s = (seconds % 60).toString().padStart(2, '0');
			      return `${h}:${m}:${s}`;
			    },
			 tableRowClassName({row, rowIndex}) {
				return 'blue-row';
			  },
			delLog(i){
				this.form.log.splice(i, 1);
			},
			addLog(){
				if(this.form.log.length>=10){
					this.$message({
						message: '商品已达到上限',
						type: 'error'
					});
				}else{
					this.form.log.push({...this.copyData})
				}
			   
			   
			},
			changeStype(){
				if(this.form.s_type==1){
					this.product  = this.product_1
				}
				if(this.form.s_type==2){
					this.product  = this.product_2
				}
				if(this.form.s_type==3){
					this.product  = this.product_3
				}
				for(let i = 0;i<this.form.log.length;i++){
					this.form.log[i].pid = ''
					this.form.log[i].num = ''
				}
			},
			toOtherEdit(type){
				let url = ''
				if(type==1){
					url = 'data_product'
				}
				if(type==2){
					url = 'user_first'
				}
				
				
				let data = {
					
				}
				this.$router.push({
					name: url,
					params:data
				})
			},
			updateTime() {
			      const now = new Date();
			      const year = now.getFullYear();
			      const month = String(now.getMonth() + 1).padStart(2, '0');
			      const day = String(now.getDate()).padStart(2, '0');
			      const hours = String(now.getHours()).padStart(2, '0');
			      const minutes = String(now.getMinutes()).padStart(2, '0');
			      const seconds = String(now.getSeconds()).padStart(2, '0');
			      
			      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			cancelOrder(e){
					this.$confirm('是否取消此订單?', '提示', {
						confirmButtonText: '確定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.axios.post('/admin/data/editStatusOrder', {
							id: e.id,
						}, {
							token: true,
							loading: true
						}).then(res => {
							let all = res.data
							if (all.code == 1) {
								this.$message({
									message: '取消成功',
									type: 'success'
								});
								this.getList()
							}
							
				
							this.layout.loading = false;
						}).catch(err => {
							this.layout.loading = false;
						})
					})
				
			},
			//提交
			submitPrint() {
				this.$refs.formEdit2.validate(res => {
					if (res) {
						this.submitPrintApi()
						// 關閉模态框
					}
				})
			},
			submitPrintApi(){
				this.printload = true
				this.axios.post('/admin/user/openPrint',
					this.printData
				, {
					token: true,
				}).then(res => {
					let all = res.data
					if (all.code == 1) {
						this.$message({
							message: all.msg,
							type: 'success'
						});
						
						
						this.printModel = false
						this.getList()
					}
					this.printload = false
				}).catch(err => {
					// 失敗
					this.printModel = false
					this.printload = false
				})
			},
			
		
		openPrintModel(e){
			this.printData = {
				id:e.id,
				log:e.log,
				no_img:e.no_img,
				go_name:e.go_name,
				addres:e.addres,
				go_phone:e.go_phone,
				go_local:e.go_local,
				time:e.time,
				e_number:e.e_number,
				client_name:e.client_name,
				phone:e.phone,
				print_img:e.print_img,
				local:e.local,
			}
			
			this.printModel = true
			this.updateTime()
		},
		
			
		
		//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					
					let list = all.data.list
				
			
					this.shop_list = list
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			  
		
		
			// 打开模态框
			openModel(e, type) {
				//let log_arr = this.deepClone(this.copyData)
				//let log_arr = [];
				//log_arr.push({...this.copyData})
				// 修改
				this.form = {
					id: 0,
					s_type:1,
					e_number:'',
					client_name:'',
					phone:'',
					local:'',
					remark:'',
					log:[]
				}
				this.product = this.product_1
				this.editIndex = e.id
				this.form.log.push({...this.copyData})
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
				
				
				if(this.tableData.length>0){
					for(let i = 0;i<this.tableData.length;i++){
						if(this.tableData[i].countdown>0){
							this.startCountdown(this.tableData[i]);
						}
						
					}
				}
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					shop_id:'',
					username:'',
					sku:'',
					number:'',
					status:this.from.status,
					type:-1,
					from_type:-1,
					s_type:-1,
					time: [],
				}

				////this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
	.protable{
		width: 94%;
		input::-webkit-outer-spin-button,
		input::-webkit-inner-spin-button {
		    -webkit-appearance: none;
		}
		input[type="number"] {
		    -moz-appearance: textfield;
		}
		inpit {
		    border: none
		}
	}
	.protable th,.protable td{
		text-align: center;
		line-height: 40px;
	}
	.tt_w{
		width: 100px;
	}
	.tt_div{
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		
		
	}
	
	.ex_model{
		display: flex;justify-content: center;
	}
	.ex_con{
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);width: 100%;color: #222;
	}
	.ex_head{
		display: flex;align-items: center;justify-content: space-between;border-bottom: 1px dashed #000;
	}
	
	.ex_head_com{
		display: flex;align-items: center;
	}
	.ex_head_logo{
		width: 40px;
	}
	.ex_head_time{
		margin-top: 5px;color: #666; font-size: 13px;
	}
	
	.ex_head_right{
		border-left: 1px solid #000;padding:8px 15px;font-size: 16px;
	}
	.ex_num{
		border-bottom: 1px dashed #000;text-align: center;font-size: 38px;padding: 10px 0;
	}
	.ex_num_img{
		text-align: center;padding: 10px 0;border-bottom: 1px solid #000;
	}
	.ex_num_img img{
		width: 85%;
	}
	
	.ex_go{
		display: flex;align-items: center;padding: 10px 0;font-size: 17px; font-weight: bold;border-bottom: 1px solid #000;
	}
	
	.ex_go_icon{
		border: 2px solid #222; width: 30px;text-align: center;margin-right: 10px;
	}
	.ex_data{
		display: flex; align-items: center;border-bottom: 1px solid #000;
	}
	.ex_data_left{
		color: #fff;width: 60px;display: flex;justify-content: center;
	}
	
	.ex_line{
		border-bottom: 1px solid #000;
	}
	
	.ex_data_left_icon{
		width: 40px;height: 40px;line-height: 40px; text-align: center;border-radius: 50%; font-size: 19; background-color: #222;
	}
	
	.ex_data_left_icon2{
		width: 30px;height: 30px;line-height: 30px; text-align: center;border-radius: 50%; font-size: 15px; background-color: #222;
	}
	
	.ex_data_right{
		border-left: 1px solid #000; padding: 5px 10px;flex:1;
	}
	.ex_data_right_name{
		padding-bottom: 10px;
	}
	.ex_data_right_phone{
		margin-left: 20px;
	}
	.ex_pro{
		padding: 10px 0;
	}
	
</style>
